module.exports = __webpack_public_path__ + "images/champion-of-the-world-71a6ab29652842f3fab0322a3d41c465.png";